import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { TIDIO_Key } from "../../constants";

const loadTidioChat = () => {
  if (!document.getElementById("tidio-script")) {
    const script = document.createElement("script");
    script.id = "tidio-script";
    script.src = `//code.tidio.co/${TIDIO_Key}`; // Replace with your Tidio script ID
    script.async = true;
    document.body.appendChild(script);
  }
};

const removeTidioChat = () => {
  const tidioScript = document.getElementById("tidio-script");
  if (tidioScript) {
    tidioScript.remove();
  }
  if (window.tidioChatApi) {
    window.tidioChatApi.hide();
  }
};

const TidioManager = () => {
  const location = useLocation(); // Get current route
  useEffect(() => {
    if (location.pathname.includes("exchange/")) {
      removeTidioChat(); // Hide if on exchange page
    } else {
      loadTidioChat(); // Load on other pages
    }
  }, [location.pathname]); // Re-run when route changes

  return null; // No UI, just logic
};

export default TidioManager;
